import { Button, Image, Loader } from '@storybook';
import { FC } from 'react';
import { useRecoilValue } from 'recoil';
import { IdentityIcon } from 'views/user-identity-flow/constants';
import {
	IdentityFlowError,
	IdentityFlowRetry,
} from 'views/user-identity-flow/store';
import { useError } from 'views/user-identity-flow/hooks';
import './error-page.scss';

interface IError {
	handleClose: () => void;
	/* SIM-52: the upgrade journey's own retry, from the hook that knows how to
	   finish an upgrade. */
	onRetryUpgrade?: () => void;
}
export const ErrorPage: FC<IError> = ({ onRetryUpgrade }) => {
	const { isLoading, onRetry } = useError();
	const reason = useRecoilValue(IdentityFlowError);
	/* Which journey failed decides what Retry re-posts: `useError`'s retry is
	   a subscription, which is the wrong request for a refused upgrade. */
	const retryKind = useRecoilValue(IdentityFlowRetry);
	const retry =
		retryKind === 'upgrade' && onRetryUpgrade ? onRetryUpgrade : onRetry;
	return (
		<div className="Error">
			<Image fileName={IdentityIcon.warning} />
			<div className="Error--info">
				<h1>Oops! Something went wrong</h1>
				<p>
					We’re sorry that you have to experience some problem! Please try again
					later.
				</p>
			</div>
			{reason ? <div className="Error--server">{reason}</div> : null}
			<Button
				handleClick={retry}
				label={isLoading ? <Loader type="loader" dimension={20} /> : 'Retry'}
				type="button__filled button__filled--primary button__large"
				disabled={isLoading}
			/>
		</div>
	);
};
